
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/explained/[slug]",
      function () {
        return require("private-next-pages/health-insurance/explained/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/explained/[slug]"])
      });
    }
  